import * as React from "react";
import BOText from "app/components/BOComponents/BOText/BOText";

class Bar extends React.Component<{}, {}> {
  render() {
    return <div className="DetailTopBar">{this.props.children}</div>;
  }
}

class Item extends React.Component<{ text: string; link: string }, {}> {
  render() {
    return (
      <BOText
        text={this.props.text}
        tag="span"
        class="BODetailItem"
        link={this.props.link}
        active="selected"
      />
    );
  }
}

export { Bar, Item };
